"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taskName = taskName;
exports.taskImprt = taskImprt;
exports.taskList = taskList;
exports.taskExportReport = taskExportReport;
exports.taskDetailList = taskDetailList;
exports.taskDetailListExport = taskDetailListExport;
exports.ticketList = ticketList;
exports.ticketListExport = ticketListExport;
exports.getColumnList = getColumnList;
exports.saveColumnConfig = saveColumnConfig;
exports.ticketConsultList = ticketConsultList;
exports.ticketConsultListExport = ticketConsultListExport;
exports.ticketComplainList = ticketComplainList;
exports.ticketComplainListExport = ticketComplainListExport;
exports.ticketComplainDownloadImage = ticketComplainDownloadImage;
exports.examReport = examReport;
exports.examReportExport = examReportExport;
exports.smsReport = smsReport;
exports.smsReportExport = smsReportExport;
exports.setColumnWidth = setColumnWidth;

var _request = _interopRequireDefault(require("@/utils/request"));

var _qs = _interopRequireDefault(require("qs"));

function taskName(query) {
  return (0, _request.default)({
    url: '/campaign/list',
    method: 'get',
    params: query
  });
}

function taskImprt(query) {
  return (0, _request.default)({
    url: '/campaign/listImport',
    method: 'get',
    params: query
  });
} //电访拨打情况报表


function taskList(query) {
  return (0, _request.default)({
    url: '/report/taskList',
    method: 'get',
    params: query
  });
}

function taskExportReport(query) {
  return (0, _request.default)({
    url: '/report/taskList',
    method: 'get',
    params: query,
    paramsSerializer: function paramsSerializer(params) {
      return _qs.default.stringify(params, {
        arrayFormat: 'repeat'
      });
    } //responseType: 'blob',

  });
} //电访任务明细报表


function taskDetailList(query) {
  return (0, _request.default)({
    url: '/report/taskDetailList',
    method: 'get',
    params: query
  });
}

function taskDetailListExport(query) {
  return (0, _request.default)({
    url: '/report/taskDetailList',
    method: 'get',
    params: query //responseType: 'blob',

  });
} //工单汇总表


function ticketList(query) {
  return (0, _request.default)({
    url: '/report/ticketList',
    method: 'get',
    params: query,
    paramsSerializer: function paramsSerializer(params) {
      return _qs.default.stringify(params, {
        arrayFormat: 'repeat'
      });
    }
  });
}

function ticketListExport(query) {
  return (0, _request.default)({
    url: '/report/ticketList',
    method: 'get',
    params: query,
    paramsSerializer: function paramsSerializer(params) {
      return _qs.default.stringify(params, {
        arrayFormat: 'repeat'
      });
    } //responseType: 'blob',

  });
} //获取报表列


function getColumnList(query) {
  return (0, _request.default)({
    url: '/report/getColumnList',
    method: 'get',
    params: query
  });
} //保存报表列设置


function saveColumnConfig(data) {
  return (0, _request.default)({
    url: '/report/saveColumnConfig',
    method: 'post',
    data: data
  });
} //工单咨询类型报表


function ticketConsultList(query) {
  return (0, _request.default)({
    url: '/report/ticketConsultList',
    method: 'get',
    params: query
  });
} //工单咨询类型明细报表


function ticketConsultListExport(query) {
  return (0, _request.default)({
    url: '/report/ticketConsultList',
    method: 'get',
    params: query //responseType: 'blob',

  });
} //投诉工单


function ticketComplainList(query) {
  return (0, _request.default)({
    url: '/report/ticketComplainList',
    method: 'get',
    params: query
  });
}

function ticketComplainListExport(query) {
  return (0, _request.default)({
    url: '/report/ticketComplainList',
    method: 'get',
    params: query //responseType: 'blob',

  });
}

function ticketComplainDownloadImage(query) {
  return (0, _request.default)({
    url: '/report/ticketComplainDownloadImage',
    method: 'get',
    params: query
  });
} //问卷结果


function examReport(query) {
  return (0, _request.default)({
    url: '/report/examReport',
    method: 'get',
    params: query
  });
}

function examReportExport(query) {
  return (0, _request.default)({
    url: '/report/examReport',
    method: 'get',
    params: query //responseType: 'blob',

  });
} //短信发送明细


function smsReport(query) {
  return (0, _request.default)({
    url: '/report/smsReport',
    method: 'get',
    params: query
  });
}

function smsReportExport(query) {
  return (0, _request.default)({
    url: '/report/smsReport',
    method: 'get',
    params: query //responseType: 'blob',

  });
}
/**
 * 设置报表列的宽度
 * @param {列名称} column 
 * @returns 
 */


function setColumnWidth(column) {
  if (column.indexOf("时间") >= 0) return 130;
  if (column.indexOf("省市") >= 0 || column.indexOf("购买产品") >= 0) return 180;
  if (column.indexOf("门店") >= 0 || column.indexOf("经销商") >= 0) return 240;
  if (column == "投诉类型1" || column == "投诉类型2" || column == "投诉类型3" || column == "投诉类型4" || column == "咨询类型1" || column == "咨询类型2" || column == "咨询类型3") return 80;
  if (column.indexOf("投诉类型") >= 0 || column.indexOf("咨询类型") >= 0) return 140;
  if (column.indexOf("沟通记录") >= 0) return 320;
  if (column.indexOf("编号") >= 0 || column.indexOf("批次") >= 0) return 120;
  if (column.indexOf("事件描述") >= 0) return 320;
  if (column.length >= 5) return 120;
  return 100;
}